/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_BadgeInputs */

const en_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Powered Marketplace`)
};

const es_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mercado impulsado por IA`)
};

const fr_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace propulsée par l'IA`)
};

const de_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gestützter Marktplatz`)
};

const ja_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIを活用したマーケットプレイス`)
};

const zh_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 驱动市场`)
};

const ar_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سوق مدعوم بالذكاء الاصطناعي`)
};

const id_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace Berbasis AI`)
};

const it_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace basato sull'IA`)
};

const ru_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейс на базе ИИ`)
};

const pt_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace impulsionado por IA`)
};

const ko_home_hero_badge = /** @type {(inputs: Home_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 기반 마켓플레이스`)
};

/**
* | output |
* | --- |
* | "AI-Powered Marketplace" |
*
* @param {Home_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_hero_badge = /** @type {((inputs?: Home_Hero_BadgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_BadgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_badge(inputs)
	if (locale === "es") return es_home_hero_badge(inputs)
	if (locale === "fr") return fr_home_hero_badge(inputs)
	if (locale === "de") return de_home_hero_badge(inputs)
	if (locale === "ja") return ja_home_hero_badge(inputs)
	if (locale === "zh") return zh_home_hero_badge(inputs)
	if (locale === "ar") return ar_home_hero_badge(inputs)
	if (locale === "id") return id_home_hero_badge(inputs)
	if (locale === "it") return it_home_hero_badge(inputs)
	if (locale === "ru") return ru_home_hero_badge(inputs)
	if (locale === "pt") return pt_home_hero_badge(inputs)
	return ko_home_hero_badge(inputs)
});